"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.financingFragmentFull = exports.financingRequestFragment = exports.financingFragment = void 0;
exports.financingFragment = `
  fragment financing on Financing {
    customerType
    downPayment
    downPaymentPercentage
    duration
    financedAmount
    id
    loanAmount
    nominalInterest
    registrationFee
    request {
      ...financingRequest
    }
    residualValue
    residualValuePercentage
    timestamp
    totalCost
    totalMonthlyCost
    totalMonthlyCostIncludingServices
  }
`;
exports.financingRequestFragment = `
  fragment financingRequest on FinancingRequest {
    agreementCode
    downPayment
    durationMonths
    id
    ignoreCampaigns
    includeFeesInFinancedAmount
    investedAmount
    isObjectDirectlyImported
    isObjectNew
    manualAdministrationFee
    manualNominalInterest
    mileage
    objectGroupCode
    objectMake
    objectModel
    registrationFee
    residualValue
    serviceAgreementPerYearFee
    timestamp
    tireHotelPerYearFee
    useDebtInsurance
  }
`;
exports.financingFragmentFull = `
  fragment financing on Financing {
    administrationFee
    annualCost
    creditCost
    customerType
    documentFee
    downPayment
    downPaymentPercentage
    duration
    effectiveInterest
    extraEquipmentSubjectToVat
    extraFeeMonthly
    financedAmount
    id
    ignoreCampaigns
    invoiceFee
    loanAmount
    minimumAdministrationFee
    minimumNominalInterest
    monthlyCostServices
    nominalInterest
    price
    registrationFee
    request {
      ...financingRequest
    }
    residualValue
    residualValuePercentage
    serviceAgreementPerYearFee
    subsidyCampaign
    tireHotelPerYearFee
    totalCost
    totalMonthlyCost
    totalMonthlyCostIncludingServices
    totalPeriodicAmount
  }
`;
//# sourceMappingURL=financing.js.map